import React from 'react';
import cx from 'classnames';
import * as styles from './Scaffold.module.css';

interface ScaffoldProps {
  header?: React.ReactNode;
  footer?: React.ReactNode;
  children: React.ReactNode;
  theme?: 'light' | 'brand';
  className?: string | null;
}

function Scaffold({
  header = null,
  footer = null,
  children,
  theme = 'light',
  className = null,
}: ScaffoldProps) {
  return (
    <div className={cx(styles.scaffold, styles[theme], className)}>
      {header && <div className={styles.header}>{header}</div>}
      <div className={styles.content}>{children}</div>
      {footer && <div className={styles.footer}>{footer}</div>}
    </div>
  );
}

export default Scaffold;
